import { ArrowForward } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { useAppSelector } from 'src/app/hooks';

export default function ChatInput({
  chatInputValue,
  isLoading,
  sendingLoading,
  handleChange,
  handleSendMessage
}: {
  chatInputValue: string;
  isLoading: boolean;
  sendingLoading: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSendMessage: (content: string) => Promise<void>;
}) {
  const { position } = useAppSelector(
    (state) => state.storeAIAssistantPosition
  );
  const { chatMode } = useAppSelector((state) => state.chatNow);
  return (
    <>
      <Box
        sx={{
          width: '100%',
          maxWidth: position === 'full' && chatMode ? '50%' : '100%',
          padding: position === 'window' ? 2 : 0,
          paddingBottom: position === 'window' ? 2 : chatMode ? '50px' : '0',
          borderTop: position === 'window' ? '1px solid #e0e0e0' : 'none'
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Box
            component="input"
            sx={{
              width: '100%',
              padding:
                position === 'window'
                  ? '8px 40px 8px 12px'
                  : '16px 40px 16px 16px',
              borderRadius: '8px',
              border: '1px solid #ddd',
              outline: 'none',
              fontSize: position === 'window' ? '14px' : '16px'
            }}
            value={chatInputValue}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !isLoading && !sendingLoading) {
                handleSendMessage(chatInputValue);
              }
            }}
            placeholder="Ask anything"
            disabled={isLoading || sendingLoading}
          />
          <Button
            sx={{
              position: 'absolute',
              right: position === 'window' ? '4px' : '8px',
              borderRadius: position === 'window' ? '50%' : '8px',
              width: position === 'window' ? '24px' : '30px',
              height: position === 'window' ? '24px' : '30px',
              minWidth: 0,
              padding: 0
            }}
            disabled={isLoading || sendingLoading}
            onClick={() => handleSendMessage(chatInputValue)}
            variant="contained"
          >
            <ArrowForward sx={{ color: '#fff' }} fontSize="small" />
          </Button>
        </Box>
      </Box>
    </>
  );
}
